<template>
  <div>
    <imageBox
      :url="data.link"
      :title="data.name"
      :remark="data.remark"
      v-if="fileType == 'image'"
    ></imageBox>
    <videoPlay
      :url="data.link"
      :title="data.name"
      :remark="data.remark"
      v-if="fileType == 'video'"
    ></videoPlay>
    <audioPlay
      :url="data.link"
      :title="data.name"
      :remark="data.remark"
      v-if="fileType == 'audio'"
    ></audioPlay>
    <pdfRead
      :url="data.link"
      :title="data.name"
      :remark="data.remark"
      v-if="fileType == 'pdf'"
    ></pdfRead>
  </div>
</template>

<script>
import { GetSource } from "@/api/mobileterminalread/index";
import imageBox from "./components/image.vue";
import videoPlay from "./components/videoPlay.vue";
import audioPlay from "./components/audioPlay.vue";
import pdfRead from "./components/pdfRead.vue";

export default {
  components: {
    imageBox,
    videoPlay,
    audioPlay,
    pdfRead,
  },
  data() {
    return {
      fileType: "",
      data: {},
    };
  },

  created() {
    if (this.$route.query.codeId) {
      this.getSource();
    } else {
      let data = {
        link: this.$route.query.filePath,
        name: this.$route.query.title,
        remark: this.$route.query.remark,
      };
      this.resourceType(data);
    }
  },
  methods: {
    getSource() {
      // let res = {downloadSuccessfully
      //   data: {
      //     // link: "https://yufengtuchuang.oss-cn-beijing.aliyuncs.com/image/boke/9.png",
      //     // link: "https://yufengtuchuang.oss-cn-beijing.aliyuncs.com/video/1730005870.mp4",
      //     link: "https://yufengtuchuang.oss-cn-beijing.aliyuncs.com/video/ni-dong-de.mp3",
      //     // link: "http://ouchn-dev-public.oss-cn-qingdao.aliyuncs.com/kecheng/kecheng/978-7-304-07459-3%E9%81%93%E8%B7%AF%E5%B7%A5%E7%A8%8B%EF%BC%9A%E7%AC%AC2%E7%89%88%20%202018.1.9.pdf",

      //     name: "这是标题",
      //     remark: "简介简介简介简介简介简介简介简介简介简介",
      //   },
      // };
      // GetSource("1569956976908177409").then((res) => {
      GetSource(this.$route.query.codeId).then((res) => {
        if (res.data && res.data.link) {
          this.resourceType(res.data);
        } else {
          this.resourceType({
            link: "/video/20240911142018.mp4",
            name: res.data.name || "资源维护中",
            remark: res.data.remark || "",
          });
        }
      });
    },

    // 判断资源类型
    resourceType(data) {
      let suffix = data.link.split("?")[0].substr(-3).toUpperCase();
      this.data = data;
      if (suffix == "MP3") {
        document.title = "资源详情";
        this.fileType = "audio";
      } else if (suffix == "MP4") {
        document.title = "资源详情";
        this.fileType = "video";
      } else if (suffix == "PDF") {
        document.title = "资源详情";
        this.fileType = "pdf";
      } else if (
        suffix == "PNG" ||
        suffix == "JPG" ||
        suffix == "JPEG" ||
        suffix == "GIF" ||
        suffix == "SVG"
      ) {
        document.title = "资源详情";
        this.fileType = "image";
      } else {
        window.location.replace(data.link);
      }
    },
  },
};
</script>
